import MerchantCategory, {
  MerchantCategoryInitializer,
} from './MerchantCategory';
import Station, { StationInitializer } from './Station';

export default class ExploreStation {
  public readonly station: Station;
  public readonly merchantCategory: MerchantCategory;
  public readonly merchantCount: number;

  constructor(init: ExploreStationInitializer) {
    this.station = new Station(init.station);
    this.merchantCategory = new MerchantCategory(init.merchantCategory);
    this.merchantCount = init.merchantCount;
  }
}

export interface ExploreStationInitializer {
  station: StationInitializer;
  merchantCategory: MerchantCategoryInitializer;
  merchantCount: number;
}
